define('site_search_button.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('site_search_button', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/SuiteCommerce/Suite_Commerce_Base_Theme/26.1.0/', 'extensions/SuiteCommerce/Suite_Commerce_Base_Theme/26.1.0/', Handlebars);
});